export default {
  route: {
    index: 'Index',
    costAnalysis: 'Cost Analysis',
    total: 'Total',
    india: 'India',
    indiaYearOnYear: 'IndiaYearOnYear',
    indiaBusinessAnalysis: 'IndiaBusinessAnalysis',
    warehousing: 'DetailedWarehousingCosts'
  },
  navbar: {
    logOut: 'Log Out',
    index: 'Index'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  button: {
    downloadExcel: 'DownloadExcel'
  },
  tableQuaryMonth: {
    january: 'January',
    february: 'February',
    march: 'March',
    Q1: 'Q1',
    april: 'April',
    may: 'May',
    june: 'June',
    Q2: 'Q2',
    july: 'July',
    august: 'August',
    September: 'September',
    Q3: 'Q3',
    October: 'October',
    november: 'November',
    december: 'December',
    Q4: 'Q4'
  },
  tableMonth: {
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    September: 'September',
    October: 'October',
    november: 'November',
    december: 'December'
  }
}
